export class Operator {
    static uniqueValues(array) {
        return Array.from(new Set(array));
    }
    static arrayChunk(array, size) {
        const out = new Array();
        for (let i = 0; i < array.length; i += size) {
            out.push(array.slice(i, i + size));
        }
        return out;
    }
    static digitGrouping(x) {
        return parseFloat(x).toLocaleString('en-US');
    }
}
//# sourceMappingURL=Operator.js.map